module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_9006.d3b6b661.png";